import React, { useState } from "react";
import { Button, Typography, Tag, Tooltip, Badge } from "antd";
import { ClockCircleOutlined, SmileOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CRITICIDADE, TIPO_TAREFA } from "../../../Misc/constants";
import { isEnfermeiro } from "Misc/utils";
import "./style.scss";
const { Text } = Typography;

const Card = ({
  isPendente,
  isAndamento,
  tipo,
  criticidade,
  panico,
  horario,
  nome,
  admin,
  initTask,
  delegateTask,
  id,
  loadingModal,
  status,
  user,
  detalhamento = false,
  atendSolicitado = false,
  tarefaConcluida = false,
  loadingTransfer,
}) => {
  const navigate = useNavigate();
  const [opacity, setOpacity] = useState(false);

  const handleClick = async () => {
    const response = await initTask(user.id, id);
    if (response) {
      switch (tipo) {
        case 2:
          navigate(`/adesao/${tipo}/${id}`);
          break;
        case 1:
          navigate(`/boasvindas/${tipo}/${id}`);
          break;
        case 3:
          navigate(`/rotina/${tipo}/${id}`);
          break;
        case 4:
          navigate(`/urgencia/${tipo}/${id}`);
          break;
        case 5:
          navigate(`/ausencia/${tipo}/${id}`);
          break;
        case 7:
          navigate(`/atendimento/${tipo}/${id}`);
          break;
        case 8:
          navigate(`/reativacao/${tipo}/${id}`);
          break;
        case 9:
          navigate(`/medicoes-incomuns/${tipo}/${id}`);
          break;
        case 10:
          navigate(`/sintomas-inflamatorios/${tipo}/${id}`);
          break;
        case 11:
          navigate(`/desvio-padrao/${tipo}/${id}`);
          break;
        default:
          console.info("[Iniciar] Default não mapeado tipo", tipo);
      }
    }
  };

  const handleClickContinue = async () => {
    switch (tipo) {
      case 2:
        navigate(`/adesao/${tipo}/${id}`);
        break;
      case 1:
        navigate(`/boasvindas/${tipo}/${id}`);
        break;
      case 3:
        navigate(`/rotina/${tipo}/${id}`);
        break;
      case 4:
        navigate(`/urgencia/${tipo}/${id}`);
        break;
      case 5:
        navigate(`/ausencia/${tipo}/${id}`);
        break;
      case 7:
        navigate(`/atendimento/${tipo}/${id}`);
        break;
      case 8:
        navigate(`/reativacao/${tipo}/${id}`);
        break;
      case 9:
        navigate(`/medicoes-incomuns/${tipo}/${id}`);
        break;
      case 10:
        navigate(`/sintomas-inflamatorios/${tipo}/${id}`);
        break;
      case 11:
        navigate(`/desvio-padrao/${tipo}/${id}`);
        break;
      default:
        console.info("[Continuar] Default não mapeado tipo:", tipo);
    }
  };

  const handleDelegate = async () => {
    setOpacity(true);
    await delegateTask(id);
    setOpacity(false);
  };

  return (
    <>
      <div className="layout-card">
        <div className="card-header">
          <Tag
            style={{
              color: CRITICIDADE[criticidade].color,
              background: CRITICIDADE[criticidade].background,
              fontWeight: "normal",
              border: "none",
            }}
          >
            {CRITICIDADE[criticidade].descricao}
          </Tag>

          <Tag
            style={{
              fontWeight: "normal",
              fontSize: "0.8rem",
            }}
            color={TIPO_TAREFA[tipo].background}
          >
            {TIPO_TAREFA[tipo].descricao}
          </Tag>
          {panico && (
            <Badge count="SOS" />
          )}
          {status === 4 && (
            <div className="buttons-group">
              <Text className="text">Cancelada</Text>
            </div>
          )}
          <div className="buttons-group">
            {isEnfermeiro(user.perfil) && (
              <>
                {isAndamento && (
                  <Button
                    disabled={loadingModal}
                    onClick={handleClickContinue}
                    type="primary"
                    className="button"
                  >
                    Continuar
                  </Button>
                )}

                {isPendente && (
                  <Button
                    onClick={handleClick}
                    type="primary"
                    className="button"
                    disabled={loadingModal}
                  >
                    Iniciar
                  </Button>
                )}
              </>
            )}

            {admin && isPendente && (
              <Button
                style={opacity ? { opacity: 1 } : {}}
                loading={opacity}
                disabled={loadingModal && !opacity}
                type="primary"
                className="button"
                onClick={handleDelegate}
              >
                Delegar
              </Button>
            )}
            {admin && detalhamento && !atendSolicitado && !tarefaConcluida && (
              <Button
                style={opacity ? { opacity: 1 } : {}}
                loading={loadingTransfer}
                disabled={loadingTransfer && !opacity}
                type="primary"
                className="button"
                onClick={handleDelegate}
              >
                Transferir
              </Button>
            )}
          </div>
        </div>
        <div className="card-info">
          <ClockCircleOutlined />
          <Text style={{ fontSize: "0.9rem" }}>{horario}</Text>
        </div>
        <div className="card-info">
          <SmileOutlined />
          <Text
            style={{
              fontSize: "0.9rem",
            }}
            ellipsis
          >
            <Tooltip mouseEnterDelay={0.5} placement="topLeft" title={nome}>
              {nome}
            </Tooltip>
          </Text>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (store) => ({
  loadingModal: store.painelatividades.loadingModal,
  loadingTransfer: store.painelatividades.loadingTransfer,
  user: store.login.user,
});

export default connect(mapStateToProps, null)(Card);
